import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormArray, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { RoleplayService, StepperContent } from '../../../service/roleplay/roleplay.service';
import { Subscription } from 'rxjs';
import { ChatService } from '../../../service/chat-service';
import { BodyColorService } from '../../../service/bodyColor/bodycolor.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../../confirmation-dialog/confirmation-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../../../service/shared/user-service.service';

@Component({
    selector: 'app-roleplay-step6',
    templateUrl: './roleplay-step6.component.html',
    styleUrl: '../../../../assets/css/roleplay.scss',
    standalone: false
})
export class RoleplayStep6Component {
  step6Form: FormGroup;
  sharedData: any = {};
  subscription: Subscription;
  profileSubscription: any = new Subscription();
  color: string = '#e8e6e3';
  inputValue: string;
  isPopupVisible: boolean = false;
  isScenarioVisible: boolean = true;
  isNextVisible: boolean = false;
  data: any = [];
  isEditMode: boolean;
  getData: any = {};
  createUpdateText: string = "created";
  ScenarioS: boolean = false;
  scenario_name: string = "";
  summary: string;
  isLoading: boolean = false;
  scenarioName: string;
  scenarioId: number;
  constructor(private route: ActivatedRoute, public Router: Router, private fb: FormBuilder, private sharedService: RoleplayService, private toastr: ToastrService,
    public ChatService: ChatService, private bodyColorService: BodyColorService, private dialog: MatDialog,
    private userServiceService: UserService) {
    this.scenarioName = this.sharedService.rolePlayScenarioData.scenario_name;
  }
  ngOnInit(): void {
    this.sharedService.editMode$.subscribe(mode => {
      this.isEditMode = mode;
      if (this.isEditMode) {
        this.ScenarioS = true;
      }
    });
    this.route.paramMap.subscribe(params => {
      this.scenarioId = +params.get('scenario_id'); // Convert to number
    });;

    this.step6Form = this.fb.group({
      customerName: ['', [Validators.required, customerNameValidator()]],
      additional_summary: [''],
      guidelineRule: this.fb.array([]),
      guidelineInputs: this.fb.array([]),
      summary: [''],
    });

    function customerNameValidator(): ValidatorFn {
      return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value?.toString();

        if (!value) return null;

        const onlyNumbers = /^[0-9]+$/.test(value);
        const onlySpecials = /^[^a-zA-Z0-9]+$/.test(value);
        const hasAlphabet = /[a-zA-Z]/.test(value);
        const onlySpace = (value || '').trim().length == 0;

        if (onlyNumbers) {
          return { onlyNumbers: true };
        }

        if (onlySpecials || onlySpace) {
          return { onlySpecials: true };
        }

        if (!hasAlphabet) {
          return { noAlphabet: true };
        }

        return null;
      };
    }

    if (this.isEditMode) {
      this.sharedService.data$.subscribe({
        next: data => {
          this.data = data;
          const updatedMetaData = this.data[0].meta_data.filter(item => item.roleplay_metadata_type === 'guideline_rule').map(items => {
            const { roleplay_metadata_val: name, id } = items;
            return { name, id }
          });
          this.scenario_name = this.data[0].scenario_name;
          const PreviousData = this.ifPreviousSelectedData();

          if (this.sharedService.rolePlayScenarioData.step5) {
            this.setGuidelineRuleData(PreviousData);
          } else {
            this.setGuidelineRuleData(updatedMetaData);
          }
          this.step6Form.patchValue({
            customerName: this.data[0].scenario_name,
            additional_summary: this.data[0].additional_summary,
            summary: this.data[0].summary,
          });
        },
        error: error => console.error('Error receiving data', error),
        complete: () => console.log('Data stream completed')
      });

    } else {
      this.subscription = this.sharedService.data$$.subscribe(response => {
        const PreviousData = this.ifPreviousSelectedData();

        if (this.sharedService.rolePlayScenarioData.step5) {
          this.setGuidelineRuleData(PreviousData);
        } else {
          this.setGuidelineRuleData(response['guideline_rule']);
        }
      }
      );
      this.step6Form.patchValue({
        summary: 'This is the default summary content. You can edit this text.'
      });
    }
    this.getSummary();
  }

  getSummary(forceRefresh = false) {
  this.isLoading = true;

  const scenarioId = this.scenarioId;
  if (!forceRefresh && !this.sharedService.hasChanges()) {
    const cachedSummary = this.sharedService.getSummaryCache(scenarioId);
    if (cachedSummary) {
      this.summary = cachedSummary.roleplay_scenario_summary;
      this.step6Form.patchValue({ summary: cachedSummary.roleplay_scenario_summary || '' });
      this.isLoading = false;
      return;
    }
  }

  // make API call
  const requestData = this.sharedService.rolePlayScenarioData;
  const apiCall$ = this.sharedService.hasChanges()
    ? this.sharedService.updateRolePlayScenarioWithId(scenarioId, requestData)
    : this.sharedService.getRoleplaySummary(requestData);

  apiCall$.subscribe(
    (res: any) => {
      this.isLoading = false;
      if (res.error) {
        this.toastr.error(res.error, 'Error', { positionClass: 'toast-top-right' });
      } else {
        this.summary = res.roleplay_scenario_summary;
        this.step6Form.patchValue({
          additional_summary: res.additional_summary || '',
          summary: res.roleplay_scenario_summary || ''
        });
        this.sharedService.setSummaryCache(scenarioId, res);
      }
    },
    (error) => {
      this.isLoading = false;
      this.toastr.error('An unexpected error occurred while fetching the summary.', 'Error', { positionClass: 'toast-top-right' });
    }
  );
}


  ifPreviousSelectedData() {
    if (this.sharedService.rolePlayScenarioData.roleplay_metadata.length) {
      const metaDataArray = this.sharedService.rolePlayScenarioData.roleplay_metadata;
      const objectiveMetaDataArray: any = metaDataArray.filter(data => {
        return data.type_name === "guideline_rule";
      });
      const updatedData = objectiveMetaDataArray.map(item => {
        const { type_value } = item;
        return { name: type_value };
      });

      return updatedData;
    }
    return [];
  }
  ScenarioName(event) {
    if (event.target.value != '') {
      this.ScenarioS = true;
    } else {
      this.ScenarioS = false;
    }
  }
  groupByMetadataType() {
    return this.data[0].meta_data.reduce((acc, item) => {
      const { roleplay_metadata_type } = item;
      if (!acc[roleplay_metadata_type]) {
        acc[roleplay_metadata_type] = [];
      }
      const { id, roleplay_metadata_val: name } = item;
      acc[roleplay_metadata_type].push({ id, name });
      return acc;
    }, {});

  }


  get guidelineInputs() {
    return this.step6Form.get('guidelineInputs') as FormArray;
  }
  get guidelineRule(): FormArray {
    return this.step6Form.get('guidelineRule') as FormArray;
  }
  addInput() {
    this.guidelineRule.push(this.fb.control(''));
  }
  removeInput(index: number): void {
    this.guidelineRule.removeAt(index);
  }

  setGuidelineRuleData(guidelineRule: any[]): void {
    const guidelineRuleFGs = guidelineRule.map(objective => this.fb.control(objective.name, Validators.required));
    const guidelineRuleFormArray = this.fb.array(guidelineRuleFGs);
    this.step6Form.setControl('guidelineRule', guidelineRuleFormArray);
  }

  updateSelected(optionIndex: number, optionId: string, event: Event, type: string) {
    this.updateSelectedSection(optionIndex, optionId, event, this.guidelineRule, 'guidelineRule');

  }
  updateSelectedSection(optionIndex: number, optionId: string, event: Event, sectionArray: any, formControlName: string) {
    sectionArray.forEach((x, i) => {
      if (i == optionIndex) {
        if (x['checked']) {
          delete x['checked']
        } else {
          x['checked'] = true;
        }
      }
    })
  }

  goBack() {
    this.sharedService.rolePlayScenarioData.roleplay_metadata =
      this.sharedService.rolePlayScenarioData.roleplay_metadata.filter(item =>
        item.type_name !== 'guideline_rule');
    let guiRule = this.step6Form.value.guidelineRule;
    if (guiRule.length > 0) {
      guiRule = guiRule.filter(item => item?.trim());
      guiRule.forEach(data => {
        this.sharedService.rolePlayScenarioData.roleplay_metadata.push(
          {
            type_name: "guideline_rule",
            type_value: data
          }
        )
      })
    }
    this.sharedService.rolePlayScenarioData.step5 = true;
    this.Router.navigate(['/app-roleplay-step5', { mode: 'roleplay' }], { skipLocationChange: true });
    this.sharedService.changeStepper({ current: 5, type: 'N' });
  }

  enterScenario() {
    const inner = document.getElementById('innercontainer');
    inner.style.display = 'none';
    this.isScenarioVisible = false;
    this.isNextVisible = true;
    this.guidelineRule.controls = this.guidelineRule.controls.filter(control => control.value !== '')
  }

  goBackScenario() {
    const inner = document.getElementById('innercontainer');
    inner.style.display = 'block';
    this.isScenarioVisible = true;
    this.isNextVisible = false;
  }

  closePopup() {
    this.isPopupVisible = false;
    this.Router.navigate(['/app-trainee-dasboard', { mode: 'roleplay' }], { skipLocationChange: true });
    this.sharedService.changeStepper({ current: 4, type: 'N' });
  }

  showDialog(createUpdateText) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      disableClose: true,
      width: '350px',
      data: { message: `You have successfully ${createUpdateText} roleplay scenario!`, okOnly: true, ok: true }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result) {
        return;
      } else {
        this.closePopup();
      }
    });
  }

  goToRoleplay() {
    this.Router.navigate(['/app-trainee-dasboard', { mode: 'roleplay' }], { skipLocationChange: true });
  }

  next() {
    if (this.step6Form.get('customerName')?.invalid) {
      this.toastr.error('Scenario name is required.')
      return;
    }
    this.sharedService.rolePlayScenarioData.roleplay_metadata =
      this.sharedService.rolePlayScenarioData.roleplay_metadata.filter(item =>
        item.type_name !== 'guideline_rule');
    this.step6Form.value.guidelineRule.forEach(data => {
      this.sharedService.rolePlayScenarioData.roleplay_metadata.push(
        {
          type_name: "guideline_rule",
          type_value: data
        }
      )
    })
    this.sharedService.rolePlayScenarioData.scenario_name = this.step6Form.value.customerName; // Updated line
    this.sharedService.rolePlayScenarioData.additional_summary = this.step6Form.value.additional_summary; // Updated line
    this.sharedService.rolePlayScenarioData.roleplay_scenario_summary = this.summary;
    const createRoleplayRequest = { ...this.sharedService.rolePlayScenarioData, created_by: this.userServiceService.userId };
    if (this.isEditMode) {
      this.sharedService.updateRolePlayScenario(this.data[0].scenario_id, createRoleplayRequest).subscribe((data: any[]) => {
        // this.isPopupVisible = true;
        this.showDialog('updated');
      });
    } else {
      this.sharedService.createRolePlayScenario(createRoleplayRequest).subscribe((data: any[]) => {
        // this.isPopupVisible = true;
        this.showDialog('created');
      });

    }
    this.sharedService.rolePlayScenarioData.dr_profile_id = 0;
    this.sharedService.clearSummaryCache();
  }

  changeStepper(stepper_data: StepperContent) {
    console.log('Step6 : changeStepper: ', stepper_data);
    this.sharedService.changeStep(stepper_data);
  }
  goBackMain() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '350px',
      data: { message: 'You will lose all changes. Do you really want to leave?' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result) {
        return;
      }
      this.Router.navigate(['/app-trainee-dasboard'], { skipLocationChange: true });
    });
  }
}
